export const SIDEBAR_DETAIL_KEYS = {
  START_DATE: 'start-date',
  END_DATE: 'end-date',
  EFFORT: 'effort',
  DURATION: 'duration',
  STUDENTS_ENROLLED: 'students-enrolled',
} as const;
